import { CheckCheck, Clock, Eye, Flag, SquarePen, Trash2 } from "lucide-react";
import Button from "../../../components/Button/Button";
import ActionMenu from "./ActionMenu";
import StatusChip from "../../../components/StatusChip/StatusChip";
import { LESSON_STATUS } from "../LessonPlannerConstant";
import { REVIEW_TAGS } from "../../WeeklyDiary/WeeklyDiaryConstant";
import { formatTimeRange, getSubjectTone } from "../utils/lessonPlanUtils";

const LessonCard = ({ lesson, isBusy, onComplete, onFlag, onView, onEdit, onDelete }) => {
  const isCompleted = lesson.status === LESSON_STATUS.COMPLETED;
  const tone = getSubjectTone(lesson.subjectName);
  const time = formatTimeRange(lesson.startTime, lesson.endTime);
  const description = lesson.objectives[0];

  return (
    <article className={`card lp-lesson-card lp-accent-${tone}`}>
      <div className="lp-lesson-card__body">
        <div className="lp-lesson-card__meta">
          <strong>{lesson.subjectName}</strong>
          <span className={`lp-dot lp-bg-${tone}`} />
          <span>{lesson.programName}</span>
          {lesson.isFlagged && (
            <StatusChip tone="danger" icon={<Flag size={10} />}>
              Flagged
            </StatusChip>
          )}
          {/* Tag set by the principal while reviewing the weekly diary */}
          {REVIEW_TAGS[lesson.reviewTag] && (
            <StatusChip tone={REVIEW_TAGS[lesson.reviewTag].tone}>{REVIEW_TAGS[lesson.reviewTag].label}</StatusChip>
          )}
        </div>
        <Button variant="plain" className="lp-btn-plain lp-lesson-card__title" onClick={() => onView(lesson)}>
          {lesson.title}
        </Button>
        {description && <p className="lp-lesson-card__desc">{description}</p>}
        <div className="lp-lesson-card__tags">
          {time && (
            <span className="lp-chip lp-chip--muted">
              <Clock size={12} /> {time}
            </span>
          )}
          {isCompleted && <StatusChip tone="success">Completed</StatusChip>}
        </div>
      </div>

      <div className="lp-lesson-card__actions">
        {isCompleted ? (
          <Button variant="outline-primary" size="sm" onClick={() => onView(lesson)}>
            View Plan
          </Button>
        ) : (
          <>
            <Button
              size="sm"
              loading={isBusy}
              onClick={() => onComplete(lesson)}
              iconRight={<CheckCheck size={14} />}
            >
              Mark as Complete
            </Button>
            <Button
              variant={lesson.isFlagged ? "outline-danger" : "light"}
              size="sm"
              className="lp-btn-icon-only"
              icon={<Flag size={14} />}
              onClick={() => onFlag(lesson)}
              disabled={isBusy}
              aria-label={lesson.isFlagged ? "Flagged" : "Flag lesson"}
              title={lesson.isFlagged ? lesson.remark || "Flagged" : "Flag lesson"}
            />
            <ActionMenu
              disabled={isBusy}
              items={[
                { label: "View", icon: Eye, onClick: () => onView(lesson) },
                { label: "Edit", icon: SquarePen, onClick: () => onEdit(lesson) },
                { label: "Delete", icon: Trash2, onClick: () => onDelete(lesson), danger: true },
              ]}
            />
          </>
        )}
      </div>
    </article>
  );
};

export default LessonCard;
